/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    this.buttons = document.querySelectorAll('.thb-widget-title.collapsible');
    this.mediaQuery = window.matchMedia('(min-width: 768px)');

    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        if (this.mediaQuery.matches) {
          return;
        }
        const expanded = button.classList.toggle('active');
        button.setAttribute('aria-expanded', expanded);
      });
    });

    this.sync();
    this.mediaQuery.addEventListener('change', () => this.sync());
  }

  sync() {
    const isDesktop = this.mediaQuery.matches;

    this.buttons.forEach((button) => {
      if (isDesktop) {
        button.setAttribute('tabindex', '-1');
        button.removeAttribute('aria-expanded');
      } else {
        button.setAttribute('tabindex', '0');
        button.setAttribute('aria-expanded', button.classList.contains('active'));
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});